import { Button, FullBox, Typography } from 'seagull';
import styles from "./APIKeysEmptyState.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const APIKeysEmptyState = _ref => {
  let {
    generateKey
  } = _ref;
  return /*#__PURE__*/_jsxs(FullBox, {
    className: styles.emptyState,
    "data-testid": "api-keys-empty-state",
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "h6",
      weight: "normal",
      "data-testid": "api-keys-empty-state-title",
      children: "No API keys created yet"
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph1",
      skin: "secondary",
      "data-testid": "api-keys-empty-state-description",
      children: "Once you generate an API key, it will appear here for reference."
    }), /*#__PURE__*/_jsx(Button, {
      onClick: generateKey,
      "data-testid": "api-keys-empty-state-generate-key-button",
      children: "Generate API key"
    })]
  });
};